import makeStyles from '@material-ui/core/styles/makeStyles';
import createStyles from '@material-ui/core/styles/createStyles';
import { useState, useEffect } from 'react';

const useStyles = makeStyles((theme) =>
  createStyles({
    partner: {
      flexGrow: 5,
      [theme.breakpoints.down('xs')]: {
        display: 'none',
      },
    },
  }),
);

const isImgExist = (src: string): Promise<boolean> => {
  return new Promise((resolve) => {
    const img = new Image();
    img.src = src;
    img.onload = () => resolve(true);
    img.onerror = () => resolve(false);
  });
};

const usePartnerLogo = (logo?: string) => {
  const [withPartnerLogo, setWithPartnerLogo] = useState(false);
  useEffect(() => {
    let callback = setWithPartnerLogo;
    if (logo) {
      isImgExist(logo).then((exists) => callback(exists));
    } else {
      setWithPartnerLogo(false);
    }

    return () => {
      // because the isImgExist Promise is an async operation which updates the state
      // it can lead to the state being updated with an old logo existance
      // for that reason we set a dummy callback on the effect destroy to make sure no async operation will set state after the prop changed
      callback = () => null;
    };
  }, [logo]);

  return {
    classes: useStyles(),
    withPartnerLogo,
  };
};

export default usePartnerLogo;
